import React, { createContext, useEffect, useState } from 'react';
import axios from 'axios';

interface User {
  id: number;
  name: string;
  email: string;
  role: string; // 'admin', 'user', etc.
}

interface AuthContextType {
  user: User | null;
  isLoading: boolean;
  error: string | null;
  checkUserRole: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextType>({
  user: null,
  isLoading: false,
  error: null,
  checkUserRole: async () => {}
});

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [user, setUser] = useState<User | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const checkUserRole = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get('/api/user/me');
      setUser(response.data);
    } catch (err) {
      setError('Failed to fetch user data');
      console.error('Error fetching user data:', err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    checkUserRole();
  }, []);

  return (
    <AuthContext.Provider value={{ user, isLoading, error, checkUserRole }}>
      {children}
    </AuthContext.Provider>
  );
};